import Config from "./config";
import Global from "./G";
import {ImportFormatManager} from "./util/ImportFormatManager";
import {LanguageManager} from "./util/LanguageManager";

export const config: Config = new Config()

export const global = new Global();

export const lm_: LanguageManager = new LanguageManager()
export const importFormatManager = new ImportFormatManager()

export const lm = lm_.FEStandard
